import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

// TODO: Pass the customized color down to the loading indicator
// once we share data between the LumaBot fab button iframe and the chat iframe,
// so we don't need to wait to load the settings/theme to have the `theme.palette.secondary.main` color available
const styles = ({
  palette: {
    primary: { main: color },
  },
}: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      left: -9999,
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: color,
      color,
      boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      animation: 'dotTyping 1.5s infinite linear',
    },
    '@keyframes dotTyping': {
      '0%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
      '16.667%': {
        boxShadow: `9984px -10px 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
      '33.333%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
      '50%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px -10px 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
      '66.667%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
      '83.333%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px -10px 0 0 ${color}`,
      },
      '100%': {
        boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
      },
    },
  });

export interface IconDotsTypingProps extends WithStyles<typeof styles>, React.HTMLAttributes<HTMLDivElement> {}

const IconDotsTyping: React.FC<IconDotsTypingProps> = ({ classes, ...rest }) => (
  <div className={classes.root} {...rest} />
);

export default withStyles(styles, { name: 'IconDotsTyping' })(IconDotsTyping);
